/**
 * Tracing for the realtime path: channel attach, message arrival, routing.
 *
 * On by default, at `console.debug` (Verbose in DevTools).
 * `localStorage.setItem("lou:quiet", "1")` silences it.
 */

const QUIET_KEY = "lou:quiet";

const quiet = () => {
  try {
    return window.localStorage.getItem(QUIET_KEY) === "1";
  } catch {
    return false;
  }
};

/**
 * Whether a command is worth tracing. Reply text arrives as one delta per few
 * characters and would bury everything else, so `conversation.*` is excluded.
 */
export const isTraced = (command?: string): boolean =>
  typeof command === "string" && !command.startsWith("conversation.");

export function louLog(event: string, detail?: unknown): void {
  if (quiet()) return;
  if (detail === undefined) {
    console.debug(`%c[Lou] ${event}`, "color:#7c5cff");
  } else {
    console.debug(`%c[Lou] ${event}`, "color:#7c5cff", detail);
  }
}

export function louWarn(event: string, detail?: unknown): void {
  if (detail === undefined) {
    console.warn(`[Lou] ${event}`);
  } else {
    console.warn(`[Lou] ${event}`, detail);
  }
}
